import { render, staticRenderFns } from "./E-commerce sector.vue?vue&type=template&id=71a6b540&scoped=true&"
import script from "./E-commerce sector.vue?vue&type=script&lang=js&"
export * from "./E-commerce sector.vue?vue&type=script&lang=js&"
import style0 from "./E-commerce sector.vue?vue&type=style&index=0&id=71a6b540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6b540",
  null
  
)

export default component.exports